{
  "version": 1,
  "asset_id": "b20c2347-f694-4627-99be-8b6e06c602cf",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/b20c2347-f694-4627-99be-8b6e06c602cf/gastric-bypass-v2-1536.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/b20c2347-f694-4627-99be-8b6e06c602cf/gastric-bypass-v2-1536.jpg",
  "original_filename": "gastric-bypass-v2-1536.jpg",
  "size": 169870,
  "content_type": "image/jpeg",
  "created_at": "2026-09-25T13:00:56Z"
}
